import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import InsuranceCoverageStep, {
	IInsuranceCoverageStepContent,
} from './InsuranceCoverageStep.component';

interface IInsuranceCoverageStepPageProps extends IPageProps {}

const InsuranceCoverageStepPage: FC<IInsuranceCoverageStepPageProps> = () => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mssp-insurance-coverage-step" }) {
				title
				breadcrumb_label
				empty_insurance_text
				add_new_plan_label
			}
		}
	`);

	const refinedContent: IInsuranceCoverageStepContent = keysToCamel(
		pageContent
	) as IInsuranceCoverageStepContent;

	return <InsuranceCoverageStep pageContent={refinedContent} />;
};

export default InsuranceCoverageStepPage;
